import adminReducer from "./adminReducer";

const storeReducer = {
  admin: adminReducer,
};

export default storeReducer;
